import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { WEB_COMPONENT_GRID_VIEW, WEB_COMPONENT_WEB_ACCESS_CONTROL_CUSTOM_PAGES_FORM } from '../../../webcomponents.constants';
import { WacPagesRecord, WebAccessControlCustomPagesGrid } from '../types';
import { WebAccessControlCustomPagesGridConfig } from './WebAccessControlCustomPagesGridConfig';
import { WebAccessControlCustomPagesGridDataProvider } from '../dataProvider/WebAccessControlCustomPagesGridDataProvider';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { Rights } from '@nirvana/shared/constants';
import { translateFn } from '../../../utils/translator.helper';
import { WebAccessControlCustomPagesFormComponent } from '../../webAccessControlCustomPagesForm';

export class WebAccessControlCustomPagesView extends BaseWebComponentView {
  public dom: {
    $hostElement: HTMLElement;
    $grid: WebAccessControlCustomPagesGrid;
    $webAccessControlCustomPagesForm: WebAccessControlCustomPagesFormComponent;
    $addPageBtn: GzButtonWebComponent;
    $deleteBtn: GzButtonWebComponent;
  };

  public getDomElements(): void {
    this.dom.$hostElement = this.shadow;
    this.dom.$grid = this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW);
    this.dom.$webAccessControlCustomPagesForm = this.shadow.querySelector(WEB_COMPONENT_WEB_ACCESS_CONTROL_CUSTOM_PAGES_FORM);
    this.dom.$addPageBtn = this.shadow.querySelector('#addBtn');
    this.dom.$deleteBtn = this.shadow.querySelector('#deleteBtn');

    if (!Application.Main.hasAllRights([Rights.MANAGE_POLICIES_WRITE])) {
      this.dom.$addPageBtn.disabled = true;
      this.dom.$deleteBtn.disabled = true;
    }
  }

  public buildView(): void {
    this.buildGrid();
    this.setTranslations();
    this.buildWebAccessControlCustomPagesForm();
  }

  private buildGrid() {
    this.dom.$grid.propertiesSet = false;
    (new WebAccessControlCustomPagesGridConfig(new WebAccessControlCustomPagesGridDataProvider(this.dependencies))).setGridViewMetadata(this.dom.$grid);
    this.dom.$grid.propertiesSet = true;
    this.dom.$grid.injectDependencies(this.dependencies);
    this.dom.$grid.start().catch(console.error);
  }

  private buildWebAccessControlCustomPagesForm() {
    if (!this.dom.$webAccessControlCustomPagesForm.injectDependencies) {
      return;
    }
    this.dom.$webAccessControlCustomPagesForm.injectDependencies(this.dependencies);
    this.dom.$webAccessControlCustomPagesForm.start().catch(console.error);
    this.dom.$webAccessControlCustomPagesForm.isVisible = false;
  }

  public showWebAccessControlCustomPagesForm(webAccessControlCustomPage?: WacPagesRecord | undefined): void {
    this.dom.$webAccessControlCustomPagesForm.propertiesSet = false;
    this.dom.$webAccessControlCustomPagesForm.isVisible = true;
    this.dom.$webAccessControlCustomPagesForm.customPage = webAccessControlCustomPage;
    this.dom.$webAccessControlCustomPagesForm.propertiesSet = true;
  }

  private setTranslations(): void {
    this.dom.$addPageBtn.textContent = translateFn('Add page');
    this.dom.$deleteBtn.textContent = translateFn('Delete');
  }
}
